import { render, staticRenderFns } from "./SelectUser.vue?vue&type=template&id=0ccfa2a4&"
import script from "./SelectUser.vue?vue&type=script&lang=js&"
export * from "./SelectUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports